export const IntroductionVideo = {
  ThumbnailUrl: 'https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F1257689274-640158d0b2899a47d1a907c1b6120f73c2ae89425c26662a53659b3c16e9a37c-d_640&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png',
  VideoUrl: 'https://player.vimeo.com/video/615748292?h=4eabdcdc40&app_id=122963'
}

